export enum FileErrorStatuses{
  RejectedBadFileOrImage = 'RejectedBadFileOrImage',
  RejectedImageFormat = 'RejectedImageFormat',
  RejectedFileSize = 'RejectedFileSize',
  RejectedImageSize = 'RejectedImageSize',
}
